var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 127 127",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2 79.9c0 7.5-6.1 13.6-13.6 13.6C6.1 93.5 0 87.4 0 79.9c0-7.5 6.1-13.6 13.6-13.6h13.6v13.6zm6.8 0c0-7.5 6.1-13.6 13.6-13.6s13.6 6.1 13.6 13.6v34.1c0 7.5-6.1 13.6-13.6 13.6s-13.6-6.1-13.6-13.6V79.9z",
    fill: "#E01E5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6 27.2c-7.5 0-13.6-6.1-13.6-13.6C34 6.1 40.1 0 47.6 0c7.5 0 13.6 6.1 13.6 13.6v13.6H47.6zm0 6.8c7.5 0 13.6 6.1 13.6 13.6s-6.1 13.6-13.6 13.6H13.6C6.1 61.2 0 55.1 0 47.6s6.1-13.6 13.6-13.6h34z",
    fill: "#36C5F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8 47.6c0-7.5 6.1-13.6 13.6-13.6 7.5 0 13.6 6.1 13.6 13.6s-6.1 13.6-13.6 13.6H99.8V47.6zm-6.8 0c0 7.5-6.1 13.6-13.6 13.6s-13.6-6.1-13.6-13.6V13.6C79.4 6.1 85.5 0 93 0s13.6 6.1 13.6 13.6v34z",
    fill: "#2EB67D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4 99.8c7.5 0 13.6 6.1 13.6 13.6 0 7.5-6.1 13.6-13.6 13.6-7.5 0-13.6-6.1-13.6-13.6V99.8h13.6zm0-6.8c-7.5 0-13.6-6.1-13.6-13.6s6.1-13.6 13.6-13.6h34.1c7.5 0 13.6 6.1 13.6 13.6s-6.1 13.6-13.6 13.6H79.4z",
    fill: "#ECB22E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/slack.23c3cff999d0ef55564b3905628cef8b.svg";
export { ForwardRef as ReactComponent };